import * as React from "react";

import {CSSProperties} from "react";
import {Spring} from "shared/core/animation/react-spring/renderprops";



export class HideFieldContainer extends React.Component<HideFieldContainerProps, HideFieldContainerState> {
    static defaultProps: Partial<HideFieldContainerProps> = {
        Immediate:false,
        IsVisible:true
    };

    spring:any;
    constructor(props: HideFieldContainerProps) {
        super(props);
        this.state = {
            Status:"resting",
            IsVisible:props.IsVisible
        };

    }


    componentWillReceiveProps(nextProps: Readonly<HideFieldContainerProps>, nextContext: any): void {
        if(nextProps.IsVisible!=this.state.IsVisible)
        {
            if(nextProps.IsVisible)
                this.setState({
                    IsVisible:true,
                    Status:"showing"
                });
            else
                this.setState({
                    IsVisible:false,
                    Status:"hidding"
                })
        }
    }

    public render() {
        let fromStyles:CSSProperties={};
        let toStyles:CSSProperties={};
        let isImmediate=false;
        toStyles.display='block';
        if(this.state.IsVisible)
        {
            fromStyles.height=0;
            fromStyles.opacity=0;
            toStyles.opacity=1;
            toStyles.height='auto';
        }else
        {
            fromStyles.height='auto';
            fromStyles.opacity=1;
            toStyles.height=0;
            toStyles.opacity=0;
        }

        if(this.state.Status=='resting')
        {
            isImmediate=true;
            if(!this.state.IsVisible)
                toStyles.display='none';
        }


        return(
            <Spring ref={node=>this.spring=node}   config={{precision:.09}}   from={fromStyles} to={toStyles} immediate={isImmediate||this.props.Immediate} onRest={x=>{if(this.state.Status!="resting")this.setState({Status:"resting"})}} onFrame={e=>{this.OnFrame(e.height,toStyles.height);}} >
                {
                    (   (styles,ref)=>{

                        return(
                            <div ref={x=>{ref(x)}}  style={{...styles,width:'100%'}}>
                                {this.props.children}
                            </div>
                        )
                    } )as any
                }
            </Spring>
        )
    }

    private OnFrame(newHeight: any, objetiveHeight: any) {
        if(objetiveHeight=='auto')
        {
            let springHeight=this.spring.controller.configs.find(x=>x.name=='height');
            if(springHeight!=null)
                objetiveHeight=springHeight.toValues[0];
        }
        newHeight=Math.round(newHeight);
        objetiveHeight=Math.round(objetiveHeight);
        if(newHeight<objetiveHeight) {

            if (newHeight >= objetiveHeight - 5) {
                this.spring.stop();
                this.setState({Status:"resting"});
            }
        }else
        if(newHeight<=objetiveHeight+5) {
            this.spring.stop();
            this.setState({Status:"resting"})
        }




    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface HideFieldContainerProps {
    IsVisible:boolean;
    Immediate:boolean;
}

interface HideFieldContainerState {
    Status:'resting'|'hidding'|'showing',
    IsVisible:boolean
}

//#endregion "My Region"